import { configAxiosInvite } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const sendRating = async data => {
    const api = configAxiosInvite();
    await api.post(ENDPOINTS.SURVEY_MONKEY_CREATE_RESPONSE, data);
};
